export default function IcBack() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M8.75 3.5L5.25 7L8.75 10.5"
        stroke="#896145"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
